import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { SEARCHFILTER_INIT_LOADING, SEARCHFILTER_INIT_SUCCESS, SEARCHFILTER_INIT_FAIL } from '@/store/types'

export const searchFilter = {
  async searchFilterInit({ commit, rootState }) {
    commit(SEARCHFILTER_INIT_LOADING)
    const apiUrl = this.state.app.menu.searchFilter
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(SEARCHFILTER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SEARCHFILTER_INIT_FAIL, extractMessages(error))
    }
  }
}
